var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cp-comments"},[_c('div',{staticClass:"cp-comments-header"},[_c('r-title',{attrs:{"type":"subtitle-2"}},[_vm._v("Комментарии")])],1),_c('comments',{attrs:{"id":_vm.id,"source_id":_vm.sourceId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }